import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PermitMobileCard = ({ permit, isSelected, onSelect, onViewDetails, onExtend, onClose }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const getStatusColor = (status) => {
    const colors = {
      active: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
      pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
      expired: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
      extended: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
      closed: 'bg-slate-100 text-slate-800 dark:bg-slate-900/30 dark:text-slate-400'
    };
    return colors?.[status] || colors?.pending;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(permit?.id, e?.target?.checked)}
          className="mt-1 w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary/20"
          aria-label={`Select permit ${permit?.permitId}`}
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <p className="font-mono text-sm font-semibold text-foreground">{permit?.permitId}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{permit?.permitType}</p>
            </div>
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(permit?.status)}`}>
              {permit?.status?.charAt(0)?.toUpperCase() + permit?.status?.slice(1)}
            </span>
          </div>

          <p className="text-sm text-foreground font-medium mb-2">{permit?.workDescription}</p>

          <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
            <div className="flex items-center gap-1">
              <Icon name="MapPin" size={12} />
              <span>{permit?.location}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="User" size={12} />
              <span>{permit?.assignedTo}</span>
            </div>
          </div>

          {isExpanded && (
            <div className="space-y-2 mb-3 pt-3 border-t border-border">
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Start Date:</span>
                <span className="text-foreground font-medium">{formatDate(permit?.startDate)}</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">End Date:</span>
                <span className="text-foreground font-medium">{formatDate(permit?.endDate)}</span>
              </div>
            </div>
          )}

          <div className="flex items-center gap-2 flex-wrap">
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              onClick={() => onViewDetails(permit?.id)}
              className="flex-1"
            >
              View
            </Button>
            {permit?.status === 'active' && (
              <Button
                variant="outline"
                size="sm"
                iconName="Clock"
                onClick={() => onExtend(permit?.id)}
                className="flex-1"
              >
                Extend
              </Button>
            )}
            {(permit?.status === 'active' || permit?.status === 'extended') && (
              <Button
                variant="ghost"
                size="sm"
                iconName="XCircle"
                onClick={() => onClose(permit?.id)}
              >
                Close
              </Button>
            )}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="ml-auto p-1 hover:bg-muted rounded"
              aria-label={isExpanded ? 'Collapse details' : 'Expand details'}
            >
              <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermitMobileCard;